module.exports = __webpack_public_path__ + "static/landon-2a3ab3c41078c7eec57478b4e04c95b5.jpg";